import { Check } from 'lucide-react';
import { Fragment } from 'react/jsx-runtime';
import { Link } from 'react-router-dom';
const AILeader = () => {
  const knowledgeAreas = [
    {
      left: 'Fundamentals of gen AI',
      // eslint-disable-next-line quotes
      right: "Google Cloud's gen AI offerings"
    },
    {
      left: 'Techniques to improve gen AI model output',
      right: 'Business strategies for a successful gen AI solution'
    }
  ];
  return (
    <div className='mx-auto max-w-7xl rounded-b-3xl rounded-tr-xl bg-white px-6 pb-12 pt-4'>
      <div className='mx-auto max-w-4xl px-6 pb-12 pt-4'>
        {/* Title */}
        <h3 className='mb-8 text-2xl font-bold text-gray-900 md:text-3xl'>
          Cloud AI Leader
        </h3>

        {/* Description Paragraphs */}
        <div className='mb-8 space-y-6 text-gray-700'>
          <p className='text-base leading-relaxed'>
            A Generative AI Leader is a visionary professional with
            comprehensive knowledge of how generative AI (gen AI) can transform
            businesses. They have business-level knowledge of Google
            Cloud&apos;s gen AI offerings and understand how Google&apos;s
            AI-first approach can lead organizations toward innovative and
            responsible AI adoption. They influence gen AI-powered initiatives
            and identify opportunities across business functions and industries,
            using Google Cloud&apos;s enterprise-ready offerings to accelerate
            innovation.
          </p>

          <p className='text-base leading-relaxed'>
            This certification is for anyone in any job role, with or without
            hands-on technical experience.
          </p>

          <p className='text-base leading-relaxed'>
            The Generative AI Leader exam assesses your knowledge in these
            areas:
          </p>
        </div>

        {/* Knowledge Areas - Two Column Grid */}
        <div className='mb-10'>
          <div className='grid grid-cols-1 gap-x-8 gap-y-4 md:grid-cols-2'>
            {knowledgeAreas.map((area, index) => (
              <Fragment key={area.left}>
                {/* Left Column Item */}
                <div className='flex items-start gap-3'>
                  <Check className='mt-0.5 h-5 w-5 flex-shrink-0 text-green-600' />
                  <span className='text-gray-700'>{area.left}</span>
                </div>

                {/* Right Column Item */}
                <div className='flex items-start gap-3'>
                  <Check className='mt-0.5 h-5 w-5 flex-shrink-0 text-green-600' />
                  <span className='text-gray-700'>{area.right}</span>
                </div>
              </Fragment>
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div className='flex flex-wrap gap-4'>
          <Link
            target='_blank'
            to='https://support.google.com/cloud-certification/#topic=9433215'
            className='rounded border-2 border-blue-600 px-8 py-3 font-medium text-blue-600 transition-colors hover:bg-blue-50'
          >
            View FAQs
          </Link>
        </div>
      </div>

      {/* Header */}
      <h3 className='mb-8 text-center text-3xl font-bold text-gray-900'>
        About this certification
      </h3>

      {/* Two Column Layout */}
      <div className='mx-auto grid max-w-6xl grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12'>
        {/* Standard Exam Information */}
        <div>
          <h2 className='mb-6 text-xl font-semibold text-gray-900'>
            Standard exam information
          </h2>

          <div className='space-y-4'>
            <div>
              <span className='font-semibold text-gray-900'>Length:</span>
              <span className='text-gray-900'> 90 minutes</span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>Content:</span>
              <span className='text-gray-900'> </span>
              <a
                href='#'
                className='text-blue-600 hover:text-blue-800 hover:underline'
              >
                exam guide
              </a>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>
                Registration fee:
              </span>
              <span className='text-gray-900'>
                {' '}
                $99 (plus tax where applicable)
              </span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>Language:</span>
              <span className='text-gray-900'> English, Japanese</span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>Exam format:</span>
              <span className='text-gray-900'>
                {' '}
                50-60 multiple choice questions
              </span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>
                Exam Delivery Method:
              </span>
              <span className='text-gray-900'>
                {' '}
                Online-proctored or onsite-proctored{' '}
              </span>
            </div>
          </div>
        </div>

        {/* Renewal Exam Information */}
        <div>
          <div className='space-y-4'>
            <div>
              <span className='font-semibold text-gray-900'>
                Validity period:
              </span>
              <span className='text-gray-900'> 3 years</span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>
                Prerequisites:
              </span>
              <span className='text-gray-900'> None</span>
            </div>
            <div>
              <span className='font-semibold text-gray-900'>Eligibility:</span>
              <span className='text-gray-900'>
                {' '}
                Candidates may renew their certification within the renewal
                eligibility period. For more information about the renewal
                process, eligibility period, and certification validity
                timeline, please refer to the Renewal FAQs below.
              </span>
            </div>

            <div className='pt-4'>
              <Link
                target='_blank'
                to='https://support.google.com/cloud-certification/answer/9907853?sjid=10159424711448208692-NC'
                className='rounded border-2 border-blue-600 px-6 py-2.5 font-medium text-blue-600 transition-colors hover:bg-blue-50'
              >
                Renewal FAQs
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AILeader;
